<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">
    <div class="card shadow-0 border-0"  style="background-color:inherit">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <form id="createQRCodeForm" name="createQRCodeForm">
              <div class="row" style="display:none;">
                <div class="col-12 mt-1">
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input class="custom-control-input chk-task-success" name="check_published" id="check_published" type="checkbox" v-model="enabled" v-bind:checked="enabled == true" />
                    <label class="custom-control-label chk-task-success" for="check_published">
                      {{$t('enabled')}}
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('name')}}
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-lg-12">
                  <input required v-model="name" type="text" id="txtname" v-bind:placeholder="$t('name')" maxlength="200" name="name" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('description')}}
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-lg-12">
                  <textarea class="skin form-control" v-bind:placeholder="$t('description')" v-model:value="description"></textarea>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('qr_what')}}
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-lg-12">
                  <div class="row mt-1">
                    <div class="col-1 pr-0 text-right">
                      <input type="radio" name="selOption" id="one" value="procedure" v-model="type" />
                    </div>
                    <div class="col-11">
                      <b>{{$t('qr_new_task')}}</b><br />
                      {{$t('qr_new_task_info')}}
                    </div>
                  </div>

                  <div class="row mt-1">
                    <div class="col-1 pr-0 text-right">
                      <input type="radio" name="selOption" id="three" value="subtask" v-model="type" />
                    </div>
                    <div class="col-11">
                      <b>{{$t('qr_subtask')}}</b><br />
                      {{$t('qr_subtask_info')}}
                    </div>
                  </div>

                  <div class="row mt-1">
                    <div class="col-1 pr-0 text-right">
                      <input type="radio" name="selOption" id="two" value="task" v-model="type" />
                    </div>
                    <div class="col-11">
                      <b>{{$t('qr_existing_task')}}</b><br />
                      {{$t('qr_existing_task_info')}}
                    </div>
                  </div>

                  <!--
                          <select v-model="type" class="form-control">
                            <option value="location">Get a list of task based on location</option>
      <option value="procedure">Create a new task and assign to the user</option>
                          <option value="task">Update an existing task</option>
                          <option value="subtask">Update a subtask from my todo-list</option>
                        </select>-->
                </div>
              </div>
              <div class="row mt-3" v-if="type == 'location'">
                <div class="col-lg-12 custom-form-label">
                  {{$t('qr_select_location_info')}}
                </div>
              </div>
              <div class="row mt-1" v-if="type == 'location'">
                <div class="col-lg-12">
                  <select v-model="locationId" class="form-control">
                    <option value="">{{$t('select_location')}}</option>
                    <option v-bind:value="menuItem.id" v-for="menuItem in locations">{{ menuItem.text }}></option>
                  </select>
                </div>
              </div>
              <!--
  <div class="row mt-3" style="display:none">
    <div class="col-lg-12 custom-form-label">
      {{$t('Always create new task')}}
    </div>
  </div>
  <div class="row mt-1" style="display:none">
    <div class="col-lg-12">
      <div class="custom-control custom-checkbox custom-control-inline">
        <input class="custom-control-input chk-task-success" name="check_genereate_new" id="check_genereate_new" type="checkbox" v-model="generate_new" v-bind:checked="generate_new == true" />
        <label class="custom-control-label chk-task-success" for="check_genereate_new">
          {{$t('enabled')}}
        </label>
      </div>
    </div>
  </div>
  -->
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('duration')}}
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-lg-12">
                  <input v-model="duration" type="text" id="qrduration" v-bind:placeholder="$t('duration')" maxlength="200" name="duration" class="form-control" />
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('meterrange')}}
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-lg-12">
                  <input v-model="meterrange" type="text" id="qrmeterrange" v-bind:placeholder="$t('meterrange')" maxlength="200" name="qrmeterrange" class="form-control" />
                </div>
              </div>

              <!--
  <div class="row mt-3" v-if="type == 'procedure'">
    <div class="col-lg-12 custom-form-label">
      {{$t('copy_existing_task_id')}}
    </div>
  </div>
  <div class="row mt-1" v-if="type == 'procedure'">
    <div class="col-lg-12">
      <input required v-model="procedureScheduleId" type="text" id="qrprocedureScheduleId" v-bind:placeholder="$t('id')" maxlength="200" name="procedureScheduleId" class="form-control" />
    </div>
  </div>-->

              <div class="row mt-3" v-if="type == 'task'">
                <div class="col-lg-12 custom-form-label">
                  {{$t('link_to_existing_task_id')}}
                </div>
              </div>
              <div class="row mt-1" v-if="type == 'task'">
                <div class="col-lg-12">
                  <input v-model="procedureScheduleId" type="text" id="qrprocedureScheduleId" v-bind:placeholder="$t('id')" maxlength="200" name="procedureScheduleId" class="form-control" />
                </div>
              </div>

              <div class="row mt-3" v-if="type == 'procedure' || type == 'subtask'">
                <div class="col-lg-12 custom-form-label">
                  {{$store.translate('procedure')}}
                </div>
              </div>

              <div class="row mt-1" v-if="type == 'procedure' || type == 'subtask'">
                <div class="col-lg-12">
                  <select v-model="procedureid" class="form-control">
                    <option value="">{{$t('select_template')}}</option>
                    <option v-bind:value="menuItem.id" v-for="menuItem in procedures">{{ menuItem.text }}</option>
                  </select>
                </div>
              </div>

              <!--
              <div class="row mt-3" v-if="procedureid != '' && type == 'subtask'">
                <div class="col-lg-12 custom-form-label">
                  {{$store.translate('sub_task')}}
                </div>
              </div>

                <div class="row mt-1" v-if="procedureid != '' && type == 'subtask'">
                  <div class="col-lg-12">
                    <select v-model="subtask" class="form-control">
                      <option value="1">Select a QR code subtask</option>
                      <option v-bind:value="menuItem.id" v-for="menuItem in subtasks">{{ menuItem.text }}</option>
                    </select>
                  </div>
                </div>
  -->
              <div class="row mt-3" v-if="procedureid != '' && type == 'subtask'">
                <div class="col-lg-12 custom-form-label">
                  {{$t('qr_subtask_link_info')}}
                </div>
              </div>
              <div class="row mt-1" v-if="procedureid != '' && type == 'subtask'">
                <div class="col-lg-12">
                  <select class="form-control" multiple
                          v-bind:class="{ 'fix-height': multiple === 'true' }"
                          v-model="multipleSubTask">
                    <option v-bind:value="menuItem.id" v-for="menuItem in subtasks">{{ menuItem.text }}</option>
                  </select>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-lg-12 custom-form-label">
                  {{$t('qr_physical_location')}} <map-button v-bind:latitude="latitude" v-bind:longitude="longitude" ref="mapButton" @on_map_click="onMapClick"></map-button>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-12">
                  <button v-show="doUpdate == false" @click="createQRCode" type="button" class="btn skin primary-button pull-right">{{ $t('save') }}</button>
                  <button v-show="doUpdate == true" @click="updateQRCode" type="button" class="btn skin primary-button pull-right">{{ $t('update') }}</button>
                  <button v-show="doUpdate == true" @click="printQRCode" type="button" class="btn skin primary-button pull-right mr-2">{{ $t('print') }}</button>
                  <a v-show="doUpdate == true" v-bind:href="'/api/scan/test?id=' + qrcodeId" target="_blank" class="btn btn-link skin primary-button pull-right mr-2">{{ $t('test') }}</a>
                </div>
              </div>
              <div class="col-12">
                <div v-if="msg != null && msg != ''" class="col-12 alert shadow-0 alert-success border-0 upload-error-message mt-3" role="alert">
                  <ul>
                    <li class="col-12">
                      {{ msg }}
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let msg = "";
  import MapButton from "../maps/map-button.vue";


  export default {
    name: "add-qrcode",
    components: {
      MapButton
    },
    props: {
      qrcodeId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        msg: "",
        name: "",
        enabled: true,
        published: "",
        type: "",
        locationId: "",
        procedureid: "",
        subtask: "",
        procedureScheduleId: "",
        doUpdate: false,
        locations: [],
        procedures: [],
        subtasks: [],
        multipleSubTask: [],
        duration: 60,
        latitude: 0,
        longitude: 0,
        optionsvisible: false,
        description: '',
        meterrange: 0

      };
    },
    methods: {
      toggleOptions() {
        this.optionsvisible = !this.optionsvisible;
      },
      onMapClick(lat, lng) {
        this.latitude = lat;
        this.longitude = lng;
        this.$refs.mapButton.setMarker(lat, lng)
      },
      resetForm() {
        this.name = '';
        this.msg = '';
        this.enabled = true;
        this.name = '';
        this.type = '';
        this.procedureid = '';
        this.subtask = '';
        this.doUpdate = false;
        this.description = '';
        this.procedureScheduleId = ""
        this.subtasks = [];
        this.duration = 60;
        this.meterrange = 0;
      },
      /**
       * https://stackoverflow.com/questions/2909033/using-javascript-to-print-images
       * Prints an image by temporarily opening a popup
       * @param {string} src - image source to load
       * @returns {void}
       */
      printQRCode(src) {
        var title = this.name;
        var description = this.description;
        var win = window.open('about:blank', "_new");
        win.document.open();
        //'   <body onload="window.print()" onafterprint="window.close()">',
        win.document.write([
          '<html>',
          '   <head>',
          '   <link href="/assets/css/all.css" rel="stylesheet" type="text/css">',
          '   </head>',
          '   <body>',
          '   <div class="container-fluid" style="max-width:270px">',
          '   <div class="row col-12">',
          '   <div class="card">',
          '       <h1 contenteditable="true" class="pt-3 pb-3 mb-0 text-center">' + title + '</h1><div style="background-color:white;padding:0px;padding-top:0px;text-align:center"><img width="190" height="190" src="' + this.qrsource + '"/></div>',
          '       <div class="card-body" contenteditable="true">' + description + '</div>',
          '   </div>',
          '   </div>',
          '   </div>',
          '   </body>',
          '</html>'
        ].join(''));
        win.document.close();
      },
      async updateQRCode() {
        if (!$('#createQRCodeForm').valid())
          return false;
        var request = {
          Name: this.name,
          Enabled: this.enabled,
          Description: this.description,
          LocationId: parseInt(this.locationId),
          Latitude: this.latitude,
          Longitude: this.longitude,
          Type: this.type,
          ProcedureId: this.procedureid,
          SubTaskId: parseInt(this.subtask),
          Duration: this.duration,
          MultipleSubTask: this.multipleSubTask.join(','),
          ProcedureScheduleId: parseInt(this.procedureScheduleId),
          MeterRange: parseInt(this.meterrange),
        };

        try {
          var response = await this.$http.post(
            '/api/QRCodes/v1/' + this.qrcodeId,
            request
          ).then(async response => {
            var rep = response.data;
            if (rep.ErrorMsg != undefined) {
              this.msg = rep.ErrorMsg;
            } else {
              //this.resetForm();
              this.$emit('refresh-qr-code');
            }
          });

        } catch (err) {
          alert(err);
        }
      },
      async createQRCode() {        
        if (!$('#createQRCodeForm').valid())
          return false;
        var request = {
          Name: this.name,
          Enabled: this.enabled,
          Description: this.description,
          LocationId: parseInt(this.locationId),
          Latitude: this.latitude,
          Longitude: this.longitude,
          Type: this.type,
          ProcedureId: this.procedureid,
          SubTaskId: parseInt(this.subtask),
          Duration: this.duration,
          MultipleSubTask: this.multipleSubTask.join(','),
          ProcedureScheduleId: parseInt(this.procedureScheduleId),
          MeterRange: parseInt(this.meterrange),
        };

        try {
          var response = await this.$http.post(
            '/api/QRCodes/v1/Code',
            request
          ).then(async response => {
            var rep = response.data;
            if (rep.ErrorMsg != undefined) {
              this.msg = rep.ErrorMsg;
              
            } else {
              //this.resetForm();
              this.qrcodeId = rep.Id;
              this.$emit('refresh-qr-code');
            }            
          });

        } catch (err) {
          alert(err);
        }
      },
      onChange(event) {
        this.selected = event.target.value;       
        //this.categoryId = parseInt(event.target.value);
      },
      async getQRCode(qrcodeId) {
        this.resetForm();
        try {          
          this.$http.get('/api/QRCodes/v1/' + qrcodeId).then(async response => {
            var qrcode = response.data;
            this.enabled = qrcode.Enabled;
            this.name = qrcode.Name;
            this.description = qrcode.Description;
            this.type = qrcode.Type;
            this.procedureid = qrcode.ProcedureId;
            this.subtask = qrcode.SubTaskId;
            this.procedureScheduleId = qrcode.ProcedureScheduleId;
            this.duration = qrcode.Duration;
           
            this.locationId = qrcode.LocationId;
            this.latitude = qrcode.Latitude;
            this.longitude = qrcode.Longitude;
            this.$refs.mapButton.latitude = this.latitude;
            this.$refs.mapButton.longitude = this.longitude;
            if (qrcode.MultipleSubTask && qrcode.MultipleSubTask != null)
              this.multipleSubTask = qrcode.MultipleSubTask.split(',');
            this.meterrange = qrcode.MeterRange;

            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadProcedures() {
        try {
          this.$http.get('/api/Procedures/v1/GetProcedures?').then(async response => {
            this.procedures = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.procedures.push({ id: response.data[i].Id, text: response.data[i].Name, display: true })
            }
            this.filterProcedures()
          });
        } catch (err) {
          alert('some error:' + err)
        }
    },
      filterProcedures() {
        var visibleItems = 0;
        for (var i = 0; i < this.procedures.length; i++) {
          if ((this.procedureFilter != null && this.procedureFilter != "" && this.procedures[i].text.toLowerCase().indexOf(this.procedureFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.procedures[i].display = false;
          }
          else {
            this.procedures[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "procedures", this.procedures);
      },
      async loadLocations() {
        try {
          this.items = [];
          this.$http.get('/api/Locations/v1?').then(async response => {
            this.locations = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.locationname.toLowerCase();
                var y = b.locationname.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              var loc = response.data[i];
              if (loc.ParentId === null) {
                //var childLocs = response.data.filter(n => n.ParentId == loc.locationid);
                var parentIds = loc.locationid;
                //childLocs.forEach(subloc => {
                //  parentIds = parentIds + ',' + subloc.locationid;
                //});
                this.locations.push({ id: parentIds, text: loc.locationname, display: true })

                //childLocs.forEach(subloc => {
                //  subloc.locationname = loc.locationname + ' > ' + subloc.locationname;
                //  this.locations.push({ id: subloc.locationid, text: subloc.locationname, display: true })
                //});
              }
            }
            this.filterLocations();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      filterLocations() {
        var visibleItems = 0;
        for (var i = 0; i < this.locations.length; i++) {
          if ((this.locationFilter != null && this.locationFilter != "" && this.locations[i].text.toLowerCase().indexOf(this.locationFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.locations[i].display = false;
          }
          else {
            this.locations[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "locations", this.locations);
      },
      loadSubTasks(procedureId) {
        this.subtasks = [];
        //GetProcedureDetail(int procedureId, string date, int? procedureScheduleId)
        try {
          this.$http.get('/api/Procedures/v1/GetProcedureElements?procedureId=' + procedureId).then(async response => {
            var subtasksresponse = response.data;
            for (var i = 0; i < subtasksresponse.length; i++) {
              if (subtasksresponse[i].ElementType == 9) {
                this.subtasks.push({ id: subtasksresponse[i].Id, text: subtasksresponse[i].Text})
              }
            }
            // Filter those subtasks that we are interested in..

            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
     
    watch: {
      qrcodeId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getQRCode(newVal);
          this.doUpdate = true;
          this.loadProcedures();
          this.loadLocations();
        }
      },
      procedureid: function (newVal, oldVal) {
        if (newVal > 0 && newVal != "") {
          this.loadSubTasks(newVal);
        }
      }
    },

    mounted() {      
      _componentValidation('#createQRCodeForm')
      if (this.qrcodeId > 0) {
        this.getQRCode(this.qrcodeId);
      }
      this.loadProcedures();
      this.loadLocations();
      
    },

    computed: {
      qrsource: {
        get: function () {
          var tmpProcedureid = "";
          //if (this.procedure != null && this.procedure.ProcedureId != 0)
          //  tmpProcedureid = this.procedure.ProcedureId;
          //else
          //  tmpProcedureid = this.procedureId;
          return apiUrl + '/api/Procedures/v1/GetQRCodeById?qrcodeid=' + this.qrcodeId + '&siteId=' + this.$store.getSiteId();
        },
      }
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/qrcode/add-qrcode.vue